import React from 'react'

export const IconFacebook = () => {
  return (
    <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M28.1324 14.5C28.1324 6.76808 21.8644 0.5 14.1324 0.5C6.40052 0.5 0.132446 6.76808 0.132446 14.5C0.132446 21.0654 4.65276 26.5747 10.7506 28.0878V18.7784H7.8638V14.5H10.7506V12.6565C10.7506 7.89144 12.9072 5.6828 17.5854 5.6828C18.4724 5.6828 20.0029 5.85696 20.629 6.03056V9.90856C20.2986 9.87384 19.7246 9.85648 19.0117 9.85648C16.7163 9.85648 15.8292 10.7262 15.8292 12.9869V14.5H20.4022L19.6165 18.7784H15.8292V28.3975C22.7615 27.5603 28.133 21.6579 28.133 14.5H28.1324Z"
        fill="#0866FF"
      />
      <path
        d="M19.6163 18.7782L20.402 14.4998H15.829V12.9867C15.829 10.726 16.7161 9.85629 19.0115 9.85629C19.7244 9.85629 20.2984 9.87365 20.6288 9.90837V6.03038C20.0027 5.85622 18.4722 5.68262 17.5852 5.68262C12.9069 5.68262 10.7504 7.89126 10.7504 12.6563V14.4998H7.86359V18.7782H10.7504V28.0876C11.8334 28.3564 12.9663 28.4998 14.1322 28.4998C14.7062 28.4998 15.2724 28.4645 15.8285 28.3973V18.7782H19.6157H19.6163Z"
        fill="white"
      />
    </svg>
  )
}
